import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  NEW_TICKET_MASSIVE_POSTPONE_PATH,
  TICKET_MASSIVE_POSTPONE_PATH,
} from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { TICKET_POSTPONE_PROCESS_COLUMNS } from '../../../../config/columns';
import {
  clearTicketPostponeProcesses,
  getTicketPostponeProcesses,
} from '../../../../actions/reservation/TicketPostponeProcess';

export const TicketMassivePostpones = ({
  breadcrumbs,
  ticketPostponeProcess,
  loading,
  dispatchGetTicketPostponeProcesses,
  dispatchClearTicketPostponeProcesses,
}) => {
  useLayoutEffect(() => () => dispatchClearTicketPostponeProcesses(), []);

  const data = ticketPostponeProcess.get('content') || [];
  const pages = ticketPostponeProcess.get('totalPages') || null;
  const defaultPageSize =
    ticketPostponeProcess.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Postergaciones Masiva de Boletos"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_TICKET_MASSIVE_POSTPONE_PATH}
      tableStructure={{
        columns: TICKET_POSTPONE_PROCESS_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetTicketPostponeProcesses,
        modelPath: TICKET_MASSIVE_POSTPONE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetTicketPostponeProcesses: getTicketPostponeProcesses,
  dispatchClearTicketPostponeProcesses: clearTicketPostponeProcesses,
};

const mapStateToProps = ({ ReservationUnit }) => ({
  breadcrumbs: [
    ...ReservationUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Postergaciones Masiva de Boletos',
      href: TICKET_MASSIVE_POSTPONE_PATH,
    },
  ],
  ticketPostponeProcess: ReservationUnit.TicketPostponeProcess.getIn([
    'all',
    'content',
  ]),
  loading: ReservationUnit.TicketPostponeProcess.getIn(['all', 'loading']),
});

TicketMassivePostpones.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  ticketPostponeProcess: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetTicketPostponeProcesses: PropTypes.func.isRequired,
  dispatchClearTicketPostponeProcesses: PropTypes.func.isRequired,
};

TicketMassivePostpones.defaultProps = {
  ticketPostponeProcess: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TicketMassivePostpones);
